import types from './types'

export default {
  setMe: (user) => ({ type: types.SET, payload: user }),
  setCompanyId: (company_id: string) => ({ type: types.SET_COMPANY_ID, payload: company_id }),
}
